import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import DownloadLink from "../../../components/common/DownloadLink";
import AdminUnifiedTable from "./AdminUnifiedTable";
import moment from "moment";

export default function AdminUnifiedIndexes() {
  const [inactives, setInactives] = useState(false);
  return (
    <div>
      <div className="d-flex justify-content-between mb-2">
        <div>
          <Form.Group controlId="formBasicCheckbox">
            <Form.Check
              checked={inactives}
              onChange={(e) => setInactives(e.target.checked)}
              type="checkbox"
              label="Показать недействующие"
            />
          </Form.Group>
        </div>
        <div>
          <DownloadLink
            variant="outline-primary"
            url="/mng/fixedPcs/0/export"
            filename={`Унифицированные показатели_${moment().format("DD.MM.yyyy")}.xlsx`}
          >
            Выгрузить в xls
          </DownloadLink>
          <Link to="/admin/indexes/0">
            <Button variant="primary" style={{ marginLeft: "8px" }}>
              + Добавить показатель
            </Button>
          </Link>
        </div>
      </div>
      <AdminUnifiedTable inactives={inactives} />
    </div>
  );
}
